import { MessageViewStore } from 'common/module/message/view-store';
import { MessageViewStoreFactory } from 'common/module/message/view-store.factory';

const service = MessageViewStoreFactory();

export function MessageService(): MessageViewStore {
  return service;
}
